import {
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertMessage from "../../../common/actions/AlertMessage";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";
import { userTalkManualPaymentAction } from "../../../redux/actions/talk_action";

function TalkManual({ amount, year, id }) {
  const [manualLoading, setManualLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleManual = async () => {
    setManualLoading(true);
    setError("");

    const response = await dispatch(
      userTalkManualPaymentAction({ amount, year, id })
    );

    setManualLoading(false);
    setConfirm(false);

    if (response?.error) {
      setError(response.error);
      return;
    }

    setOpen(true);
  };

  return (
    <>
      {error && <AlertMessage type="error" message={error} />}
      <Button
        color="amber"
        disabled={manualLoading}
        onClick={() => {
          setError("");
          setConfirm(true);
        }}
      >
        {manualLoading ? <Spinner color="white" /> : "Manual Pay"}
      </Button>

      {open && (
        <Dialog open={open} handler={() => setOpen(false)}>
          <DialogHeader>
            <Typography variant="h5" color="blue-gray">
              Your manual payment request has been added. Complete payment at
              the Bar Secretariat.
            </Typography>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="text"
              color="blue-gray"
              onClick={() => navigate("/home/talk")}
            >
              Close
            </Button>
          </DialogFooter>
        </Dialog>
      )}

      {confirm && (
        <ConfirmPayment
          open={confirm}
          setOpen={setConfirm}
          title="Manual"
          amount={amount}
          loading={manualLoading}
          handleConfirm={handleManual}
          handleClose={() => setConfirm(false)}
        />
      )}
    </>
  );
}

export default TalkManual